import { useReseller } from 'hooks/Reseller/useReseller';
import { readCookie } from 'utils/Cookies';
import { Environment } from 'utils/Environment';

export const useDefaultReseller = (referralId?: string, referralIdDev?: string) => {
  const { setReferralHostId } = useReseller();
  const isDev = Environment.current.isDev;
  const isMissingReferralId = !referralId && !referralIdDev;
  const isReferralIdInCookie = !!readCookie('referralId');

  if (isMissingReferralId || isReferralIdInCookie) return;

  if (isDev && referralIdDev) {
    setReferralHostId(referralIdDev);
  }

  if (!isDev && referralId) {
    setReferralHostId(referralId);
  }
};
